import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateTaskEventTypeMutationVariables = Types.Exact<{
  input: Types.CreateTaskEventTypeInput;
}>;


export type CreateTaskEventTypeMutation = { __typename?: 'Mutation', createTaskEventType: { __typename?: 'TaskEventTypePayload', taskEventType?: { __typename?: 'TaskEventTypeStateData', taskEventTypeId: string, name: string, description: string, status: Types.TaskEventTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateTaskEventTypeMutationVariables = Types.Exact<{
  input: Types.UpdateTaskEventTypeInput;
}>;


export type UpdateTaskEventTypeMutation = { __typename?: 'Mutation', updateTaskEventType: { __typename?: 'TaskEventTypePayload', taskEventType?: { __typename?: 'TaskEventTypeStateData', taskEventTypeId: string, name: string, description: string, status: Types.TaskEventTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateTaskEventTypeMutationVariables = Types.Exact<{
  input: Types.ActivateTaskEventTypeInput;
}>;


export type ActivateTaskEventTypeMutation = { __typename?: 'Mutation', activateTaskEventType: { __typename?: 'TaskEventTypePayload', taskEventType?: { __typename?: 'TaskEventTypeStateData', taskEventTypeId: string, name: string, description: string, status: Types.TaskEventTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateTaskEventTypeMutationVariables = Types.Exact<{
  input: Types.InactivateTaskEventTypeInput;
}>;


export type InactivateTaskEventTypeMutation = { __typename?: 'Mutation', inactivateTaskEventType: { __typename?: 'TaskEventTypePayload', taskEventType?: { __typename?: 'TaskEventTypeStateData', taskEventTypeId: string, name: string, description: string, status: Types.TaskEventTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteTaskEventTypeMutationVariables = Types.Exact<{
  input: Types.DeleteTaskEventTypeInput;
}>;


export type DeleteTaskEventTypeMutation = { __typename?: 'Mutation', deleteTaskEventType: { __typename?: 'TaskEventTypePayload', taskEventType?: { __typename?: 'TaskEventTypeStateData', taskEventTypeId: string, name: string, description: string, status: Types.TaskEventTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type TaskEventTypeFieldsFragment = { __typename?: 'TaskEventTypeStateData', taskEventTypeId: string, name: string, description: string, status: Types.TaskEventTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, tenantId: string };

export const TaskEventTypeFieldsFragmentDoc = new TypedDocumentString(`
    fragment TaskEventTypeFields on TaskEventTypeStateData {
  taskEventTypeId
  name
  description
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}
    `, {"fragmentName":"TaskEventTypeFields"});
export const CreateTaskEventTypeDocument = new TypedDocumentString(`
    mutation CreateTaskEventType($input: CreateTaskEventTypeInput!) {
  createTaskEventType(input: $input) {
    taskEventType {
      ...TaskEventTypeFields
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskEventTypeFields on TaskEventTypeStateData {
  taskEventTypeId
  name
  description
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const UpdateTaskEventTypeDocument = new TypedDocumentString(`
    mutation UpdateTaskEventType($input: UpdateTaskEventTypeInput!) {
  updateTaskEventType(input: $input) {
    taskEventType {
      ...TaskEventTypeFields
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskEventTypeFields on TaskEventTypeStateData {
  taskEventTypeId
  name
  description
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const ActivateTaskEventTypeDocument = new TypedDocumentString(`
    mutation ActivateTaskEventType($input: ActivateTaskEventTypeInput!) {
  activateTaskEventType(input: $input) {
    taskEventType {
      ...TaskEventTypeFields
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskEventTypeFields on TaskEventTypeStateData {
  taskEventTypeId
  name
  description
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const InactivateTaskEventTypeDocument = new TypedDocumentString(`
    mutation InactivateTaskEventType($input: InactivateTaskEventTypeInput!) {
  inactivateTaskEventType(input: $input) {
    taskEventType {
      ...TaskEventTypeFields
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskEventTypeFields on TaskEventTypeStateData {
  taskEventTypeId
  name
  description
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
export const DeleteTaskEventTypeDocument = new TypedDocumentString(`
    mutation DeleteTaskEventType($input: DeleteTaskEventTypeInput!) {
  deleteTaskEventType(input: $input) {
    taskEventType {
      ...TaskEventTypeFields
    }
    errors {
      code
      message
    }
  }
}
    fragment TaskEventTypeFields on TaskEventTypeStateData {
  taskEventTypeId
  name
  description
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
  tenantId
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateTaskEventType: build.mutation<CreateTaskEventTypeMutation, CreateTaskEventTypeMutationVariables>({
      query: (variables) => ({ document: CreateTaskEventTypeDocument, variables })
    }),
    UpdateTaskEventType: build.mutation<UpdateTaskEventTypeMutation, UpdateTaskEventTypeMutationVariables>({
      query: (variables) => ({ document: UpdateTaskEventTypeDocument, variables })
    }),
    ActivateTaskEventType: build.mutation<ActivateTaskEventTypeMutation, ActivateTaskEventTypeMutationVariables>({
      query: (variables) => ({ document: ActivateTaskEventTypeDocument, variables })
    }),
    InactivateTaskEventType: build.mutation<InactivateTaskEventTypeMutation, InactivateTaskEventTypeMutationVariables>({
      query: (variables) => ({ document: InactivateTaskEventTypeDocument, variables })
    }),
    DeleteTaskEventType: build.mutation<DeleteTaskEventTypeMutation, DeleteTaskEventTypeMutationVariables>({
      query: (variables) => ({ document: DeleteTaskEventTypeDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateTaskEventTypeMutation, useUpdateTaskEventTypeMutation, useActivateTaskEventTypeMutation, useInactivateTaskEventTypeMutation, useDeleteTaskEventTypeMutation } = injectedRtkApi;
